/**
 * Allowlist für Links, deren Ziel aus fremdem HTML stammt.
 *
 * Der Veranstaltungskalender auf activate-hr.de wird serverseitig per regulärem
 * Ausdruck ausgelesen (`apps/api/src/modules/status-reports/events.ts`); das
 * `href` kommt also unverändert von einer fremden Seite in den Bericht. React
 * blockt `javascript:`-URLs **nicht** — es schreibt nur eine Warnung in die
 * Konsole und rendert den Link trotzdem (Befund W9).
 *
 * Deshalb: Es überleben ausschließlich absolute `http:`/`https:`-Adressen.
 * Alles andere — auch eine relative Angabe — wird zu `null`, und die
 * Komponente rendert statt eines Links reinen Text. Bewusst keine Auflösung
 * relativer Pfade gegen den eigenen Ursprung: Ein Pfad aus fremdem Markup soll
 * nicht als Link auf die eigene Anwendung enden.
 */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  // Vorprüfung vor `new URL`: Der Konstruktor akzeptiert jedes Schema, auch
  // `javascript:` und `data:`.
  if (!/^https?:\/\//i.test(trimmed)) return null;
  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.toString()
      : null;
  } catch {
    return null;
  }
}
